import { UP_DESKTOP, WithHalfdot } from "@elyxeer/ui";
import Typography from "@mui/material/Typography";

/**
 * The heading of one dashboard section — "Moje rutina", "Co je nového" and the rest.
 *
 * A step down the named scale on desktop only. On a phone the dashboard has no page
 * title (the lockup stands in for one), so each section heading is the top of the page
 * and keeps `H1`. On desktop the page opens with a greeting in `H1`, and sections set
 * in the same size read as a stack of equal titles rather than a page with parts, so
 * they take `H2` there.
 */
export function SectionHeading({ children }: { children: string }) {
  return (
    <Typography
      variant="H1"
      sx={(theme) => ({
        color: "text.primary",
        [UP_DESKTOP]: theme.typography.H2,
      })}
    >
      <WithHalfdot size={10}>{children}</WithHalfdot>
    </Typography>
  );
}
